function getDefaultSelect({
  id,
  name,
  list,
  valueField,
}) {
  if (id == null || id === '') {
    return
  }
  const hasCurrentId = list?.map(item => item[valueField]).includes(id)
  if (hasCurrentId) {
    return {
      id,
    }
  }
  return {
    name,
  }
}

export default (Vue) => {
  Vue.directive('selectDefault', {
    /**
     * @param {Element} el
     * @param {Object} binding
     */
    updated(el, binding) {
      const input = el.querySelector('.el-input input')
      let value = input.value
      function setDefaultSelect() {
        const current = getDefaultSelect(binding.value)
        if (current == null) {
          return
        }
        if (current?.id != null) {
          return
        }
        if (value === current?.name) {
          return
        }
        value = current?.name || ''
        input.value = value
      }
      Promise.resolve().then(() => {
        setDefaultSelect()
      })
    },
  })
}
